var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-header'),_c('router-view'),_c('v-footer'),_c('img',{staticClass:"fix-btn",attrs:{"src":require("./assets/gotop.png")},on:{"click":_vm.goTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }